<template>
  <div class="todaysMenu responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Inventory" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'inventoryReport', label: 'Inventory' },
        { name: 'inventoryReports', label: listPageHeader.title },
      ]" buttonLabel="New" routerPath="superset" :pageHeader="listPageHeader" :hideAddButton="true">
        <ReportFilter style="margin-bottom: -20px;" @submit-filter="performGetReport"
          :isLoading="loadingStatus.getTodaysMenu" :filterByStoreOrOrg="filterByStoreOrOrg"
          :filterByMemoType="filterByCreditMemoType" :filterByItemLocation="filterByItemLocation"
          :filterByItemType="filterByItemType" :filterByText="filterByText" :filterByTime="filterByTime"
          :filterBySaleType="filterBySaleType" />
      </PageHeader>
      <div style="width: 100%; height: 85vh;" v-if="url">
        <iframe id="frame" width="100%" height="100%" style="border:none" :src="url"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeaderReports.vue";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import { supersetHelpers } from "@/utils/superset";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "todaysMenu",
  data() {
    return {
      listPageHeader: {
        title: "Inventory",
        isEditorView: false,
      },
      Utilities: Utilities,
      filter: { selectedReportSaleType: '' },
      url: undefined,
      urlParams: {},
      reportName: "",
      filterByTime: false,
      filterByText: false,
      filterByItemLocation: false,
      filterByCreditMemoType: false,
      filterByItemType: false,
      filterByStoreOrOrg: true,
      filterBySaleType: false,
      reportConfig: null,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.parseUrlParams();
  },
  mounted() {
    this.getReportSettings();
  },
  watch: {
    reportSettings: function (newVal) {
      this.setReportMeta();
    }
  },
  computed: {
    ...mapGetters({
      loadingStatus: "todaysMenuModule/loadingStatus",
      todaysMenu: "todaysMenuModule/todaysMenu",
      currentStore: "storeModule/currentStore",
      reportSettings: "reports/reportSettings",
    }),
  },
  methods: {
    ...mapActions({ getReportSettings: "reports/getReportSettings", }),
    parseUrlParams() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      this.urlParams = params;
    },
    performGetReport(filter) {
      this.filter = filter
      this.getReport(filter)
    },
    getReport(filter) {
      const report = this.reportConfig;
      const reportSettings = this.reportSettings;
      const url = supersetHelpers.getReportUrl(report, reportSettings, filter, this.currentStore);
      this.url = `${url}&_ts=${Date.now()}`;
    },
    setReportMeta() {
      const report = this.reportSettings?.reportConfigs?.find(report => report.slug === this.urlParams.name);
      const isMedicalStore = this.currentStore?.isMedical ?? false;
      if (report) {
        this.reportConfig = report;
        this.filterByTime = report.filterByTime;
        this.filterByCreditMemoType = report.filterByCreditMemoType;
        this.filterByText = report.filterByText;
        this.filterByItemLocation = report.filterByItemLocation;
        this.filterByItemType = report.filterByItemType;
        this.filterByStoreOrOrg = report.filterByStoreOrOrg;
        this.filterBySaleType = report.filterBySaleType && isMedicalStore;
        this.reportName = report.slug;
        this.listPageHeader.title = report.name;
        this.setPageTitle(report.name);
      }
    }
  }
};
</script>

<style lang="scss"></style>
